import { TemplateRef } from "@angular/core";

export const DefaultDataSourceOpts = {
  cluster: true,
  clusterMaxZoom: 4,
  clusterRadius: 25,
  maxZoom: 10,
  tolerance: 0.5
};

export interface IMapPoint {
  point: atlas.data.Feature<atlas.data.Geometry, any>;
  popup?: TemplateRef<any>;
  layerName: string;
}

export class MapPoint {
  point: atlas.data.Feature<atlas.data.Geometry, any>;
  layerName: string;

  constructor(data: IMapPoint);
  constructor(args: any) {
    this.point = args.point
    this.layerName = args.layerName;
  }
}

export interface IMapPointGroup {
  points: MapPoint[];
  layerOpts?: atlas.SymbolLayerOptions | atlas.BubbleLayerOptions;
  sourceOpts?: atlas.DataSourceOptions;
  groupName: string;
}

export class MapPointGroup {
  points: MapPoint[];
  datasource?: atlas.source.DataSource;
  layer?: atlas.layer.Layer;
  popupRef?: string | HTMLElement;
  groupName: string;

  constructor(data: IMapPointGroup);
  constructor(data: any) {
    this.points = data.points;
    this.groupName = data.groupName;
    if(data.popupRef){
      this.popupRef = data.popupRef;
    }
    if(data.sourceOpts) {
      this.datasource = new atlas.source.DataSource(name, data.sourceOpts);
    } else {
      this.datasource = new atlas.source.DataSource(name, DefaultDataSourceOpts);
    }
    if(data.layerOpts) {
      this.layer = new atlas.layer.SymbolLayer(this.datasource, `${data.groupName}Layer`, data.layerOpts);
    } else {
      this.layer = new atlas.layer.SymbolLayer(this.datasource, `${data.groupName}Layer`);
    }
  }
}